/**
 * Bloomyer Newsletter — Form submission with confirmation
 * Custom element: <bn-newsletter>
 */

if (!customElements.get('bn-newsletter')) {
  class BnNewsletter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('.bn-form');
      this.input = this.querySelector('.bn-form__input');
      this.success = this.querySelector('.bn-success');
      this.error = this.querySelector('.bn-error');
      this.btn = this.querySelector('.bn-form__btn');

      if (!this.form) return;

      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    async handleSubmit(e) {
      e.preventDefault();

      const email = this.input.value.trim();
      if (!email) return;

      this.success.classList.remove('is-visible');
      this.error.classList.remove('is-visible');
      this.btn.disabled = true;
      this.btn.textContent = '...';

      try {
        const formData = new FormData();
        formData.append('contact[email]', email);
        formData.append('contact[tags]', 'newsletter');

        const res = await fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (res.ok) {
          this.success.classList.add('is-visible');
          this.input.value = '';
        } else {
          this.error.classList.add('is-visible');
        }
      } catch {
        this.error.classList.add('is-visible');
      } finally {
        this.btn.disabled = false;
        this.btn.textContent = "S'INSCRIRE";
      }
    }
  }

  customElements.define('bn-newsletter', BnNewsletter);
}
